import { render, staticRenderFns } from "./is_FBA.vue?vue&type=template&id=2cdefc6f&scoped=true&"
import script from "./is_FBA.vue?vue&type=script&lang=js&"
export * from "./is_FBA.vue?vue&type=script&lang=js&"
import style0 from "./is_FBA.vue?vue&type=style&index=0&id=2cdefc6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdefc6f",
  null
  
)

export default component.exports